export default page => {
  const routes = (page || window.location.pathname)
    .split('/')
    .filter(r => r !== 'dashboard')
    .filter(Boolean);

  return routes.length ? routes.slice(0, 1) : ['map'];
};
